import { createLogger, format, transports } from "winston";
import Moment from "moment";

const logger = (module: string) => {
  return createLogger({
    level: process.env.NODE_ENV === "development" ? "debug" : "warn", // debug, info, warn, error
    silent: false,
    format: format.combine(
      format.timestamp(),
      format.label({ label: module }),
      format.splat(),
      format.printf((obj : any) => {
        const splat = obj[Symbol.for("splat") as any] || [];
        return `[${Moment(obj.timestamp).format(
          "HH:mm:ss"
        )}] ${obj.level.toUpperCase()} ${obj.label} :: ${
          obj.message
        } ${splat
          .filter((s: any) => typeof s === "object")
          .map((s: any) => JSON.stringify(s, null, 2))}`;
      })
    ),
    transports: [new transports.Console()],
  });
};
export default logger;
